export enum ResultType {
    None = 0,
    Success = 1,
    Failed = 2,
    Pending = 3
}